(ns dre.pages.frontpage.topic-search.templates.treatment-patterns
  (:require
   [dre.i18n.views :refer [tr]]))

(def template
  {:treatment-patterns {:title [tr "Treatment Patterns"]
                        :form-sub-heading [:<>
                                           [:span [tr "Please add one or more terms for any category."]]
                                           [:span [tr "After clicking “View Results”, you can edit your question and/or search criteria."]]]
                        :forms-type :common
                        :forms [{:title [tr "Interventions"] 
                                 :form-id :intervention
                                 :form-type :common
                                 :required? false
                                 :top-terms-type ["I"]
                                 :operator :or
                                 :examples [{:pill/type :senses
                                             :pill/query "SUyz"
                                             :pill/other-senses (list "SUBESP"),
                                             :pill/excluded-senses (list),
                                             :pill/label "Monoclonal Antibody"}
                                            {:pill/type :term
                                             :pill/query "SUN9PT"
                                             :pill/label "Pembrolizumab"}
                                            {:pill/type :term
                                             :pill/query "SUDspt"
                                             :pill/label "Mepolizumab"}
                                            {:pill/type :term
                                             :pill/query "SUDbK"
                                             :pill/label "Enalapril"}]}
                                {:title [tr "Conditions"] 
                                 :form-id :conditions
                                 :form-type :common
                                 :required? false
                                 :top-terms-type ["DIS"]
                                 :operator :and
                                 :examples [{:pill/type :term
                                             :pill/query "SUBAB"
                                             :pill/label "Asthma"}
                                            {:pill/type :term
                                             :pill/query "S0Bf_"
                                             :pill/label "Breast cancer"}
                                            {:pill/type :term
                                             :pill/query "SUJY3"
                                             :pill/label "Stroke"}
                                            {:pill/type :senses
                                             :pill/query "SUEly"
                                             :pill/other-senses (list "SUElz"),
                                             :pill/excluded-senses (list),
                                             :pill/label "Heart Failure"}]}
                                {:title [tr "Demographics"] 
                                 :form-id :demographics
                                 :form-type :common
                                 :required? false
                                 :top-terms-type ["DEM"]
                                 :operator :and
                                 :examples [{:pill/type :term
                                             :pill/query "SUVI3"
                                             :pill/label "Male"}
                                            {:pill/type :term
                                             :pill/query "SUVEQ"
                                             :pill/label "Female"}
                                            {:pill/type :term
                                             :pill/query "SUcB"
                                             :pill/label "Elderly"}
                                            {:pill/type :term
                                             :pill/query "SUKLo"
                                             :pill/label "United States"}]}]
                        :review-query-render-fn (fn [items search-query-template]
                                                  [:span.text (str " What are the treatment patterns of ") (:intervention items) 
                                                   " in " (:demographics items)  " population(s) with "
                                                   (:conditions items)
                                                   "?"])
                        :default-search-query-template :accuracy
                        :search-query-templates {:accuracy {:query/pill
                                                            {:pill/type "boost"
                                                             :pill/pills
                                                             [{:pill/type "and"
                                                               :pill/pills
                                                               [{:pill/type "tag"
                                                                 :pill/query "predicted/drug_utilization_postfilter"
                                                                 :pill/label "Treatment patterns"}
                                                                {:template-type :intervention
                                                                 :pill/type "sentence-tag"
                                                                 :pill/query "title-or-abstract-or-keywords"}
                                                                {:template-type :conditions
                                                                 :pill/type "sentence-tag"
                                                                 :pill/query "title-or-keywords"}
                                                                {:template-type :demographics
                                                                 :pill/type "sentence-tag"
                                                                 :pill/query "title-or-abstract-or-keywords"}]} 
                                                              {:template-type :intervention
                                                               :pill/type "sentence-tag"
                                                               :pill/query "title"}
                                                              {:template-type :conditions
                                                               :pill/type "sentence-tag"
                                                               :pill/query "title"}
                                                              {:template-type :demographics
                                                               :pill/type "sentence-tag"
                                                               :pill/query "title"}]}
                                                            :response/filter
                                                            {:search/count true :search/count-1w true :search/count-6m true}}}}})